module.exports = __webpack_public_path__ + "files/3144e6d0bde12dbae217f1d29807af8d.png";